<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit" :lazy-validation="true">
    <v-card>
      <v-card-title>
        <span class="headline">{{ titlePrefix }} Side order</span>
      </v-card-title>
      <v-card-text>
        <v-text-field name="sideordername" v-model="ownItem.name" label="Name" :rules="stringValidation" autocomplete="off"></v-text-field>
        <!-- <v-textarea name="description" v-model="ownItem.description" label="Description" :auto-grow="true" rows="1" :rules="stringValidation"></v-textarea> -->
        <v-text-field name="price" v-model="ownItem.price" label="Price" suffix=":-" type="tel" :rules="priceValidation" autocomplete="off"></v-text-field>
        <v-select :items="itemGroupsOptions" v-model="ownItem.itemgroup" label="Item group" :rules="stringValidation"></v-select>
        <v-checkbox
          v-model="ownItem.hidden"
          label="Hidden"
          messages="Hidden side orders are not shown in the app and can't be bought"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn depressed :disabled="!valid" :loading="isSaving" color="primary" type="submit">Save</v-btn>
        <v-btn text @click="cancel" color="primary">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
function isNumeric(n) {
  return /^[0-9]+$/g.test(n);
}

export default {
  props: {
    item: {
      type: Object
    },
    itemGroups: {
      type: Array
    }
  },
  data () {
    return {
      valid: true,
      stringValidation: [v => (v != null && v !== '') || 'Cannot be empty'],
      priceValidation: [
        v => v !== '' || 'Cannot be empty',
        v => v != null || 'Must be a number',
        v => isNumeric(v) || 'Must be a whole number',
        v => v >= 0 || 'Can\'t be negative'
      ],
      ownItem: {},
      imageName: 'dync-appshop-product-image.jpg',
      image: null,
      hadImage: false
    }
  },
  computed: {
    isSaving () {
      return this.$store.getters.isLoadingFor(['sideorders.create', 'sideorders.update']);
    },
    titlePrefix () {
      return this.ownItem.id ? 'Edit' : 'Add';
    },
    itemGroupsOptions () {
      var options = this.itemGroups.slice(0);
      options = options.map((item) => {
        return {
          value: item.id,
          text: item.name +'  (Vat '+ item.vat + '%)'
        }
      });
      options.sort((a, b) => {
        if (a.text > b.text) {
          return 1;
        } else if (a.text < b.text) {
          return -1;
        } else {
          return 0
        }
      });
      return options;
    }
  },
  watch: {
    item: {
      immediate: true,
      handler (newVal) {
        this.setOwnItem(newVal);
      }
    }
  },
  methods: {
    setOwnItem (item) {
      if (item) {
        this.ownItem = Object.assign({}, item);
      } else {
        this.ownItem = {};
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    submit () {
      if (!this.$refs.form.validate()) {
        return;
      }
      const item = Object.assign({}, this.ownItem);

      this.$emit('submit', item);
    },
    cancel () {
      this.$emit('cancel');
    },
    reset () {
      this.setOwnItem(null);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
